import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_30, COLOR_GRAY_70, COLOR_PINK, COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  grayColor: {
    color: COLOR_GRAY_70,
    fontFamily: 'Lato',
    textAlign: 'left',
  },
  title: {
    fontSize: 34,
    color: COLOR_PURPLE,
    textAlign: 'center',
  },
  secondaryColor: {
    color: COLOR_PINK,
    fontFamily: 'Lato',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'baseline',
    gap: 4,
  },
  month: {
    fontSize: 18,
  },
  priceCard: {
    marginBottom: theme.spacing(4),
    borderRadius: 16,
    backgroundColor: theme.palette.common.white,
    boxShadow: '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)',
    border: '1px solid #E0E0E0',
    '& p, & > span': {
      fontFamily: 'Lato',
    },
    '& a': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },

    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  priceCardActiveSecondary: {
    position: 'relative',
    border: `1px solid ${COLOR_PINK}`,
    boxShadow: '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)',
  },
  cardTitle: {
    color: COLOR_GRAY_70,
    fontSize: 18,
    fontWeight: 700,
    fontFamily: 'Lato',
  },
  cardTitleEmphasis: {
    color: COLOR_PINK,
  },
  tagMostPopular: {
    display: 'block',
    color: COLOR_PINK,
    fontSize: 14,
    fontWeight: 700,
    fontFamily: 'Lato',
    background: '#FDF2FA',
    padding: '2px 8px',
    border: '1px solid #FCCEEE',
    borderRadius: 6,
    width: 'fit-content',
  },
  discountText: {
    color: '#D6246E',
    fontSize: 16,
    fontFamily: 'Lato',
  },
  textBannerLocale: {
    color: theme.palette.common.white,
    fontSize: 23,

    '& .extra': {
      display: 'inline',
      textDecoration: 'underline',
      fontSize: 23,
    },

    '& span': {
      fontSize: 40,
      fontWeight: 900,
    },
  },
  freeDays: {
    fontSize: 14,
    color: COLOR_GRAY_70,
    fontFamily: 'Lato',
    lineHeight: '19px',
  },
  textPrice: {
    color: COLOR_GRAY_70,
    fontSize: 11,
    fontFamily: 'Lato',
    lineHeight: '19px',
    textAlign: 'left',
  },
  line: {
    backgroundColor: COLOR_PINK,
    height: 1,
    minWidth: 100,
    flexGrow: 1,
    flexBasis: 0,
  },
  priceCardActiveGray: {
    position: 'relative',
    border: `1px solid ${COLOR_GRAY_30}`,
    boxShadow: '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)',
  },
  benefitsList: {
    minWidth: 613,
    lineHeight: '8px',

    '& div': {
      display: 'flex',
      alignItems: 'center',
    },

    '& svg': {
      color: COLOR_PINK,
    },

    '& p': {
      color: COLOR_GRAY_70,
      fontSize: 16,
      fontFamily: 'Lato',
      marginLeft: 8,
    },

    [theme.breakpoints.down('lg')]: {
      minWidth: '100%',
      lineHeight: '20px',
    },
  },
  allFeatures: {
    color: COLOR_PINK,
    textDecoration: 'underline',
    fontSize: 14,

    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
